import React from 'react';

import { PrimaryFilters as PrimaryFiltersProvider } from 'components/Filters';

import {
  FILTER_DATE,
  FILTER_TIME_ZONE,
  FILTER_APPLICATIONS,
} from '../../constants';
import HourlyTrackerFilters from './filters';

export const PRIMARY_FILTERS = [
  FILTER_DATE,
  FILTER_TIME_ZONE,
  FILTER_APPLICATIONS,
];

const PrimaryFilters = () => {
  return (
    <PrimaryFiltersProvider primary={PRIMARY_FILTERS}>
      <HourlyTrackerFilters.Date />
      <HourlyTrackerFilters.TimeZone />
      <HourlyTrackerFilters.Applications withClear={true} />
      <HourlyTrackerFilters.Networks withClear={true} />
      <HourlyTrackerFilters.Platforms withClear={true} />
      <HourlyTrackerFilters.TrafficType withClear={true} />
      <HourlyTrackerFilters.Countries withClear={true} />
      <HourlyTrackerFilters.Affiliates
        dropdownWidth={'440px'}
        withClear={true}
      />
      <HourlyTrackerFilters.Managers withClear={true} />
      <HourlyTrackerFilters.Owners withClear={true} />
    </PrimaryFiltersProvider>
  );
};

export default PrimaryFilters;
